import CardPackshot from "../CardPackshot";
import ImgProgressBar from "../Loaders/ImgProgressBar";
import { useEffect, useState } from "react";
import useGenericContentStore from "../../store/genericContent.store";
import { Props } from "./model";
import { StyledTitle, StyledContainer, StyledGrid, StyledGridCenter, StyledImage, StyledProgressTitle } from "./styled";
import useScreenDimensions from "../../hooks/useScreenDimensions";

const CardGridPlaylist = (props: Props) => {
	const [gridSize, setGridSize] = useState<any>();
	const isNarrow = useGenericContentStore((state: any) => state.isNarrow);
	const { width } = useScreenDimensions();

	/**
	 * useEffect to detect resize on window
	 */
	useEffect(() => {
		const resizeHandler = () => {
			setGridSize(calculateGridItemsByWindowWidth(width));
		};
		resizeHandler();

		window.addEventListener("resize", resizeHandler);
		return () => window.removeEventListener("resize", resizeHandler);
	}, [width]);

	/**
	 * Function to calculate the number of items on grid
	 * based on window width
	 * @param width - window width size
	 * @returns {number} - number of items in grid
	 */
	const calculateGridItemsByWindowWidth = (width: any) => {
		if (width >= 1660) return props.isClips ? 4 : 6;

		if (width >= 620 && width < 1660) return 4;

		if (width < 620) return props.isClips ? 3 : 4;
	};

	const getColumnCount = () => {
		if (props?.isClips || props?.isStudioAccess || props?.isExtras) {
			return 5;
		}

		return 10;
	};
	return (
		//@ts-ignore
		<StyledContainer>
			{/* @ts-ignore */}
			{props.title && !props.hideTitle && !props.isAggregate ? <StyledTitle isNarrow={isNarrow}>{props.title}</StyledTitle> : <></>}
			{!props.title && !props.hideTitle && !props.isAggregate ? (
				// @ts-ignore
				<StyledProgressTitle isNarrow={isNarrow}>
					<ImgProgressBar />
				</StyledProgressTitle>
			) : (
				<></>
			)}
			{props.data?.length !== 0 ? (
				//@ts-ignore
				<StyledGridCenter isExtras={props.isExtras}>
					{/* @ts-ignore */}
					<StyledGrid
						gridSize={isNarrow ? getColumnCount() : gridSize}
						isNarrow={isNarrow}
						isExtras={props.isExtras}
						isStudioAccess={props.isStudioAccess}
						isToggleMQTT={props.isToggleMQTT}
					>
						{props.data?.map((item: any, index: number) => {
							return (
								// @ts-ignore
								<StyledImage
									isClips={props.isClips}
									isNarrow={isNarrow}
									isExtras={props.isExtras}
									isStudioAccess={props.isStudioAccess}
									key={`grid-products-${item.parentProductId ?? item.id}-${index}`}
								>
									{!props.isClips ? (
										<CardPackshot
											key={item.parentProductId}
											productId={item.parentProductId}
											image={item.packshots}
											hideBorder={props.hideBorder}
											isProgressBar={item.isProgressBar}
											isRedeem={props.isRedeem}
											disabled={props.disabled}
											isPreview={props?.isPreview}
											isHome={props?.isHome}
										/>
									) : (
										<></>
									)}
									{props.isClips ? (
										<CardPackshot
											key={item.id}
											productId={props.isAggregate ? item.productId : props.parentProductId}
											vamId={item.uniqueContentId}
											image={item.imageUrl}
											title={item.title}
											isAssignToScreen={props.isAssignToScreen}
											isRedeem={item?.vamStatus === 1 || item?.vamStatus === 3 || props.isRedeem}
											isLandscape={props.isClips}
											isClips={props.isClips}
											isStudioAccess={props.isStudioAccess}
											isVamAggregate={props.isAggregate}
											hideBorder={props.hideBorder}
											vamStatus={item.vamStatus}
											disabled={props.disabled}
											isPreview={props?.isPreview}
											isHome={props?.isHome}
											customListId={props.customListId}
											isExtras={props.isExtras}
										/>
									) : (
										<></>
									)}
								</StyledImage>
							);
						})}
					</StyledGrid>
				</StyledGridCenter>
			) : (
				<></>
			)}
		</StyledContainer>
	);
};

export default CardGridPlaylist;
